import React, { Component } from "react";
import "axios";
import ProgressBar from "./ProgressBar";
import './Progress.css';

const ProgressData = [
    { id: 1, skill: "html/css", completed: "80%" },
    { id: 2, skill: "javascript", completed: "45%" },
    { id: 3, skill: "python", completed: "50%" },
    { id: 4, skill: "django", completed: "50%" },
    { id: 5, skill: "bootstrap", completed: "70%" },
    { id: 6, skill: "tachyons", completed: "60%" },
    { id: 7, skill: "react js", completed: "40%" }
]
const Data = ProgressData.map(data => {
    return (
        <div className="container" id="skill">
            <div className="row">
                <ProgressBar key={data.id} name={data.skill} value={data.completed} />
            </div>
        </div >
    )
})

class Progress extends Component {
    render() {
        return (
            <div>
                {Data}
            </div>
        )
    }
}

export default Progress;
